/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import Img from "react-cool-img";

// components
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";

// Icons
import Facebook from "assets/socialIcon/facebook.svg";
import Instagram from "assets/socialIcon/instagram.svg";
import Line from "assets/socialIcon/line.svg";

import LOGO_WHITE from "assets/logo/logo_nav_lightgray.svg";

const useStyles = makeStyles((theme) => ({
	container: {
		background:
			"linear-gradient(to right, rgba(219,136,209,0.8), rgba(176,255,2555,0.8))",
		padding: "64px 0px 64px 0px",
		fontSize: "12px",
		color: "#999999",
	},
	link: {
		color: "#fff",
		opacity: 0.8,
		fontWeight: 900,
		cursor: "pointer",
		fontSize: "14px",
		"&:hover": {
			opacity: 1,
		},
		textDecoration: "none",
	},
	breakLine: {
		marginTop: 24,
		marginBottom: 24,
		border: "1px solid white",
	},
	title: {
		color: "white",
		fontSize: 24,
		fontWeight: 900,
		marginBottom: 12,
	},
	text: {
		color: "white",
		fontSize: 18,
		lineHeight: 1.8,
	},
	contactText: {
		color: "white",
		fontSize: 14,
	},
	icon: {
		width: 24,
	},
	tag: {
		color: "white",
		marginRight: 6,
		fontWeight: "bold",
		textDecoration: "none",
		"&:hover": {
			color: "#ff84aa",
		},
	},
}));

const Tags = [
	{
		label: "相片列印",
		url: "https://creator.memopresso.com/",
	},
	{
		label: "IG列印",
		url: "https://creator.memopresso.com/",
	},
	{
		label: "插畫相框",
		url: "https://creator.memopresso.com/",
	},
	{
		label: "相片沖洗",
		url: "https://creator.memopresso.com/",
	},
	{
		label: "紀念小物",
		url: "https://creator.memopresso.com/",
	},
	{
		label: "證件照",
		url: "https://creator.memopresso.com/",
	},
];

function Footer(props) {
	const classes = useStyles(props);

	const tabs = [
		{
			name: "產品",
			link: `${window.location.origin}#prods`,
			target: "_self"
		},
		{
			name: "操作說明",
			link: `${window.location.origin}#howtouse`,
			target: "_self"
		},
		{
			name: "創作者相框",
			link: `${window.location.origin}#creators`,
			target: "_self"
		},
		{
			name: "關於",
			link: `${window.location.origin}#about`,
			target: "_self"
		},
		{
			name: "聯絡我們",
			link: `${window.location.origin}#contact`,
			target: "_self"
		},
		{
			name: "點位圖",
			link: `${window.location.origin}#sitemap`,
			target: "_self"
		},
		{
			name: "平台政策",
			link: `${window.location.origin}/policy`,
			target: "_self"
		},
		{
			name: "服務介紹",
			link: `https://medium.com/memopresso`,
			target: "_blank"
		},
	];

	const renderTags = () => {
		return _.map(Tags, ({ label, url }) => (
			<a className={classes.tag} href={url} target="_blank">
				{`#${label}`}
			</a>
		));
	};

	return (
		<div className={classes.container}>
			<Container maxWidth="md">
				<Box display="flex" justifyContent="center" mt={3} mb={4}>
					<Img
						placeholder={LOGO_WHITE}
						src={LOGO_WHITE}
						error={LOGO_WHITE}
						alt={`logo_white`}
					/>
				</Box>
				<Grid container spacing={2}>
					<Grid item xs={12} md={7}>
						<Typography variant="h5" className={classes.title}>
							關於
						</Typography>
						<span className={classes.text}>
							透過個性化社群軟體與軟硬整合，無人零售的技術，插畫家、
							<br />
							創作者合作，提供年輕一代使用者快速保存，製作與分享個性化相片的解決方案，打造“有感社交”
							的社群分享體驗。
							<br />
							<br />
							{renderTags()}
						</span>
					</Grid>
					<Grid item xs={12} md={1}></Grid>
					<Grid item xs={12} md={4}>
						<Typography variant="h5" className={classes.title}>
							網頁導覽
						</Typography>
						{_.map(tabs, ({ name, link, target }, index) => (
							<Box mb={2} key={`item-${index}`}>
								<a className={classes.link} target={target} href={link}>
									{`> ${name}`}
								</a>
							</Box>
						))}
					</Grid>
				</Grid>
			</Container>
			<hr className={classes.breakLine}></hr>
			<Container maxWidth="md">
				<Grid container spacing={1}>
					<Grid item xs={12} md={6} className={classes.contactText}>
						<Box pt={3}>
							客服電話 : 02-37655060
							<br />
							客服信箱 : business@memopresso.com
						</Box>
					</Grid>
					<Grid item xs={12} md={2}></Grid>
					<Grid item xs={12} md={4}>
						<IconButton
							className={classes.link}
							onClick={() => {
								window.open(
									`https://www.instagram.com/memopresso/`,
									"_blank"
								);
							}}
						>
							<Img
								className={classes.icon}
								placeholder={Instagram}
								src={Instagram}
								error={Instagram}
								alt={`instagram_logo`}
							/>
						</IconButton>

						<IconButton
							className={classes.link}
							onClick={() => {
								window.open(
									`https://www.facebook.com/memopresso/`,
									"_blank"
								);
							}}
						>
							<Img
								className={classes.icon}
								placeholder={Facebook}
								src={Facebook}
								error={Facebook}
								alt={`facebook_logo`}
							/>
						</IconButton>

						<IconButton
							className={classes.link}
							onClick={() => {
								window.open(`https://lin.ee/lW6nRzP`, "_blank");
							}}
						>
							<Img
								className={classes.icon}
								placeholder={Line}
								src={Line}
								error={Line}
								alt={`line_logo`}
							/>
						</IconButton>
						<br />
						<div style={{ color: "white", paddingLeft: 12 }}>
							{`© Memopresso ${new Date().getFullYear()}`}
						</div>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
}

export default Footer;
